import { createSlice } from '@reduxjs/toolkit'

const LogoStatus = Object.freeze({
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
})

const initialState = {
    status: LogoStatus.LOADING,
    errorMessage: null,
}

const logoSlice = createSlice({
    name: 'business/logo',
    initialState,
    reducers: {
        uploadLogoRequest: state => {
            state.status = LogoStatus.LOADING
        },
        uploadLogoRequestSuccess: state => {
            state.status = LogoStatus.SUCCESS
        },
        uploadLogoRequestError: (state, action) => {
            state.errorMessage = action.payload
            state.status = LogoStatus.FAILURE
        },
        reset: state => initialState,
    },
})

const {
    uploadLogoRequest,
    uploadLogoRequestSuccess,
    uploadLogoRequestError,
    reset,
} = logoSlice.actions

export const logoActions = {
    uploadLogoRequest,
    uploadLogoRequestSuccess,
    uploadLogoRequestError,
    reset,
}

export const logoSelectors = {
    isFetching: state => state.businessLogo.status === LogoStatus.LOADING,
    hasError: state => state.businessLogo.status === LogoStatus.FAILURE,
    success: state => state.businessLogo.status === LogoStatus.SUCCESS,
    errorMessage: state => state.businessLogo.errorMessage,
}

export default logoSlice.reducer
